<template>
    <div class="home">
      <AssetList v-show="listView" @newAsset="onClickNewFromList" @editAsset="onClickEditFromList" :scroll="corY" ref="refreshList" />
      <AssetForm v-show="formView" :asset="asset" @backClicked="onBackChild" @onBack="onBack" backReload="backReload"/>
    </div>
</template>
<script>
import AssetList from '@/components/finance/AssetList.vue'
import AssetForm from '@/components/finance/AssetForm.vue'
import Axios from 'axios'
import { assetUrl, getHeader } from '@/config'
import { mapState } from 'vuex'
export default {
  name: 'Asset',
  components: {
    AssetForm,
    AssetList
  },
  mounted () {
    this.$store.dispatch('getAssetTypeList')
    this.$store.dispatch('getAccountList')
    this.$store.dispatch('getCompanyList')
    this.$store.dispatch('getUomList')
  },
  computed: {
    ...mapState({
      authUser: state => state.users.authUser
    })
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      asset: {
        id: null,
        asset_no: null,
        type_id: null,
        asset_name: null,
        date_buy: null,
        date_reduce: null,
        date_process: null,
        asset_age: null,
        asset_age_remaining: null,
        asset_amount: '0',
        asset_amount_reduce: '0',
        asset_fix_amount: '0',
        outlet_code: null,
        account_code: null,
        serial_number: null,
        internal_number: null,
        description: null,
        memo_no: null,
        status: null,
        sell_date: null,
        sell_amount: '0',
        company_no: null,
        condition: null,
        active: null,
        fuel_qty_reference: '0',
        fuel_uom_reference: null,
        fuel_qty_bigger: '0',
        fuel_uom_bigger: null,
        logs: [{
          id: null,
          asset_id: null,
          amount: '0',
          process_date: null,
          log_age: null,
          log_date: null,
          company_no: null
        }],
        journal: [{
          id: null,
          journal_code: null,
          journal_description: null,
          account: null,
          account_code: null,
          remark: null,
          debit: '0',
          credit: '0',
          journal_date: null
        }],
        famaintenance: [{
          id: null,
          asset_no: null,
          memo_no: null,
          maintenance_date: null,
          description: null,
          subtotal: null,
          discount: null,
          tax_type: null,
          tax: null,
          total: null,
          vendor_no: null,
          company_no: null
        }]
      }
    }
  },
  methods: {
    async backReload (id) {
      this.onClickEditFromList(id)
    },
    onClickNewFromList: function (value) {
      this.asset = {
        id: null,
        asset_no: null,
        type_id: null,
        asset_name: null,
        date_buy: null,
        date_reduce: null,
        date_process: null,
        asset_age: null,
        asset_age_remaining: null,
        asset_amount: '0',
        asset_amount_reduce: '0',
        asset_fix_amount: '0',
        outlet_code: null,
        account_code: null,
        serial_number: null,
        internal_number: null,
        description: null,
        memo_no: null,
        status: 'in',
        sell_date: null,
        sell_amount: '0',
        company_no: this.authUser.company_no,
        condition: null,
        active: true,
        fuel_qty_reference: '0',
        fuel_uom_reference: null,
        fuel_qty_bigger: '0',
        fuel_uom_bigger: null,
        logs: [{
          id: null,
          asset_id: null,
          amount: '0',
          process_date: null,
          log_age: null,
          log_date: null,
          company_no: null
        }],
        journal: [{
          id: null,
          journal_code: null,
          journal_description: null,
          account: null,
          account_code: null,
          remark: null,
          debit: '0',
          credit: '0',
          journal_date: null
        }],
        famaintenance: [{
          id: null,
          asset_no: null,
          memo_no: null,
          maintenance_date: null,
          description: null,
          subtotal: null,
          discount: null,
          tax_type: null,
          tax: null,
          total: null,
          vendor_no: null,
          company_no: null
        }]
      }
      this.listView = false
      this.formView = true
      // this.$store.dispatch('getEmployees')
      this.$store.dispatch('getVendorList')
    },
    onClickEditFromList: function (value) {
      console.log('onClickEditFromList', value)
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      Axios.get(assetUrl + '/' + value, { headers: getHeader() })
        .then(response => {
          console.log(response.data.data)
          this.asset = response.data.data
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
      this.listView = false
      this.formView = true
      this.$store.dispatch('getVendorList')
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.asset = {
        id: null,
        asset_no: null,
        type_id: null,
        asset_name: null,
        date_buy: null,
        date_reduce: null,
        date_process: null,
        asset_age: null,
        asset_age_remaining: null,
        asset_amount: '0',
        asset_amount_reduce: '0',
        asset_fix_amount: '0',
        outlet_code: null,
        account_code: null,
        serial_number: null,
        internal_number: null,
        description: null,
        memo_no: null,
        status: null,
        sell_date: null,
        sell_amount: '0',
        company_no: null,
        condition: null,
        active: false,
        fuel_qty_reference: '0',
        fuel_uom_reference: null,
        fuel_qty_bigger: '0',
        fuel_uom_bigger: null,
        logs: [{
          id: null,
          asset_id: null,
          amount: '0',
          process_date: null,
          log_age: null,
          log_date: null,
          company_no: null
        }],
        journal: [{
          id: null,
          journal_code: null,
          journal_description: null,
          account: null,
          account_code: null,
          remark: null,
          debit: '0',
          credit: '0',
          journal_date: null
        }],
        famaintenance: [{
          id: null,
          asset_no: null,
          memo_no: null,
          maintenance_date: null,
          description: null,
          subtotal: null,
          discount: null,
          tax_type: null,
          tax: null,
          total: null,
          vendor_no: null,
          company_no: null
        }]
      }
      this.$refs.refreshList.refreshAsset()
    },
    onBack: function (value) {
      // console.log(value)
      this.$refs.refreshList.refreshAsset()
      this.onClickEditFromList(value)
    }
  }
}
</script>
